module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nlet field, fieldProperties, renderGranted\nif(formMapping.modelFieldIndex >= 0 && model.fields && (field = model.fields[formMapping.modelFieldIndex]) && field.atom){\nfieldProperties = (model.fieldProperties || {})[field.fieldCode || '~~~NOT_EXISTING_FIELD~~~'] || {}\nrenderGranted = field.atom.renderType && field.atom.renderType != 'none' && !fieldProperties.preventRender\nif(renderGranted){\nconst fieldConfig = field.config || {};\nlet formBasePath = '../';\nlet fieldPath = '';\nlet hidden = false;\nlet disabled = false;\nlet isFilterField = false;\nlet preventFieldLabel = Boolean(config.preventAllFieldLabels);\nlet additionalClasses = '';\nif(formMapping.fieldConfig){\nif(formMapping.fieldConfig.hidden || fieldConfig.hidden){\nhidden = true;\n}\nif(formMapping.fieldConfig.disabled || fieldConfig.disabled){\ndisabled = true;\n}\nif(formMapping.fieldConfig.isFilterField){\nisFilterField = true;\n}\nif(formMapping.fieldConfig.preventFieldLabel || fieldConfig.preventFieldLabel){\npreventFieldLabel = true;\n}\n// TODO: CS: really?\nif(formMapping.fieldConfig.additionalClasses || fieldConfig.additionalClasses){\nadditionalClasses = formMapping.fieldConfig.additionalClasses;\n}\nif(formMapping.fieldConfig.fieldPath){\nfieldPath = '../../../' + formMapping.fieldConfig.fieldPath.replace(/^\\//, '').replace(/\\/$/, '');\n}\n}\nif(fieldConfig.formBasePath){\nformBasePath = '../../../' + String(fieldConfig.formBasePath).replace(/^\\//, '').replace(/\\/$/, '') + '/';\n}\nif(!fieldPath){\nif(fieldConfig.fieldPath){\nfieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\\//, '').replace(/\\/$/, '');\n} else if(field.atom.renderType !== 'custom') {\nfieldPath = formBasePath + 'fields/' + field.atom.renderType;\n}\n}\npreventFieldLabel = preventFieldLabel || isFilterField || fieldConfig.preventFieldLabel;\nfield.label = '';\nfield.description = '';\nfield.information = '';\nfield.placeholder = '';\nif((field.lang || {})[(storage || {}).langCode || 'MISSING_LANG_CODE']){\nconst currentLangData = field.lang[storage.langCode];\nif(currentLangData.label){\nfield.label = currentLangData.label;\nfield.placeholder = currentLangData.label;\n}\nif(currentLangData.description){\nfield.description = currentLangData.description;\n}\nif(currentLangData.information){\nfield.information = currentLangData.information;\n}\n}\nif(formMapping.labelKey){\nfield.label = storage.__(formMapping.labelKey);\nfield.placeholder = field.label;\n}\nif(isFilterField){\nfield.placeholder = storage.__('filter') + ' ' + field.placeholder;\n}\nlet classes = ['form-group', 'col-12', 'field']\nif(disabled)            classes.push('disabled');\nif(hidden)              classes.push('hidden');\nif(additionalClasses)   classes = classes.concat(String(additionalClasses).trim().split(' '));\nclasses.push(`fieldOf_${field.fieldCode}`)\nconst fieldComponentConfig = (field.config || {}).componentConfig || {}\nfieldComponentConfig.bootstrapVersion = 5\nconst labelConfig = {\nbootstrapVersion: fieldComponentConfig.bootstrapVersion\n}\n%><div class=\"<%= classes.join(' ') %>\"><%\nif(fieldPath && !hidden){\nif(!preventFieldLabel){\n// if(!preventFieldLabel && field.atom.renderType !== 'checkbox' && field.atom.renderType !== 'toggle'){\n%><%- include('label', { formMapping: formMapping, model: field, config: labelConfig }); %><%\n}\n%><%- include(fieldPath, { formMapping: formMapping, model: field, config: fieldComponentConfig }); %><%\n// if(!preventFieldLabel && (field.atom.renderType === 'checkbox' || field.atom.renderType === 'toggle')){\n%><%#- include('label', { formMapping: formMapping, model: field, config: labelConfig }); %><%\n// }\n// checkboxes use the description as text right of the checkbox itself which conflicts with the tooltip (which is rendered according to the description field too).\nif(field.description && field.atom.renderType !== 'checkbox'){\n%><%- include('form-text', { model: { message: field.description } }); %><%\n}\n} else {\n// TODO: hidden???\n%><span class=\"hidden-<%- field.fieldCode %>\"></span><%\n}\n%></div><%\n}\nelse {\n// TODO: hidden???\n%><span class=\"hidden-<%- field.fieldCode %>\"></span><%\n}\n}\n// TODO: render static fields\n// else {\n//     const renderType = formMapping.renderType;\n//     const fieldCode = (formMapping.fieldCode || {}).tpl;\n//     const fieldConfig = formMapping.fieldConfig || {};\n//     const fieldPath = '../fields/' + renderType;\n//     const fieldModel = {\n//         fieldCode,\n//         additionalCSSClass: (fieldConfig.additionalClasses || []).join(' ')\n//     }\n//\n//     if(renderType && fieldCode){\n//        %><%#- include(fieldPath, { formMapping: formMapping, model: fieldModel }); %><%\n//    }\n// }\n%>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\bootstrap5\\form\\elements\\field.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
let field, fieldProperties, renderGranted
if(formMapping.modelFieldIndex >= 0 && model.fields && (field = model.fields[formMapping.modelFieldIndex]) && field.atom){
fieldProperties = (model.fieldProperties || {})[field.fieldCode || '~~~NOT_EXISTING_FIELD~~~'] || {}
renderGranted = field.atom.renderType && field.atom.renderType != 'none' && !fieldProperties.preventRender
if(renderGranted){
const fieldConfig = field.config || {};
let formBasePath = '../';
let fieldPath = '';
let hidden = false;
let disabled = false;
let isFilterField = false;
let preventFieldLabel = Boolean(config.preventAllFieldLabels);
let additionalClasses = '';
if(formMapping.fieldConfig){
if(formMapping.fieldConfig.hidden || fieldConfig.hidden){
hidden = true;
}
if(formMapping.fieldConfig.disabled || fieldConfig.disabled){
disabled = true;
}
if(formMapping.fieldConfig.isFilterField){
isFilterField = true;
}
if(formMapping.fieldConfig.preventFieldLabel || fieldConfig.preventFieldLabel){
preventFieldLabel = true;
}
// TODO: CS: really?
if(formMapping.fieldConfig.additionalClasses || fieldConfig.additionalClasses){
additionalClasses = formMapping.fieldConfig.additionalClasses;
}
if(formMapping.fieldConfig.fieldPath){
fieldPath = '../../../' + formMapping.fieldConfig.fieldPath.replace(/^\//, '').replace(/\/$/, '');
}
}
if(fieldConfig.formBasePath){
formBasePath = '../../../' + String(fieldConfig.formBasePath).replace(/^\//, '').replace(/\/$/, '') + '/';
}
if(!fieldPath){
if(fieldConfig.fieldPath){
fieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\//, '').replace(/\/$/, '');
} else if(field.atom.renderType !== 'custom') {
fieldPath = formBasePath + 'fields/' + field.atom.renderType;
}
}
preventFieldLabel = preventFieldLabel || isFilterField || fieldConfig.preventFieldLabel;
field.label = '';
field.description = '';
field.information = '';
field.placeholder = '';
if((field.lang || {})[(storage || {}).langCode || 'MISSING_LANG_CODE']){
const currentLangData = field.lang[storage.langCode];
if(currentLangData.label){
field.label = currentLangData.label;
field.placeholder = currentLangData.label;
}
if(currentLangData.description){
field.description = currentLangData.description;
}
if(currentLangData.information){
field.information = currentLangData.information;
}
}
if(formMapping.labelKey){
field.label = storage.__(formMapping.labelKey);
field.placeholder = field.label;
}
if(isFilterField){
field.placeholder = storage.__('filter') + ' ' + field.placeholder;
}
let classes = ['form-group', 'col-12', 'field']
if(disabled)            classes.push('disabled');
if(hidden)              classes.push('hidden');
if(additionalClasses)   classes = classes.concat(String(additionalClasses).trim().split(' '));
classes.push(`fieldOf_${field.fieldCode}`)
const fieldComponentConfig = (field.config || {}).componentConfig || {}
fieldComponentConfig.bootstrapVersion = 5
const labelConfig = {
bootstrapVersion: fieldComponentConfig.bootstrapVersion
}

    ; __line = 81
    ; __append("<div class=\"")
    ; __append(escapeFn( classes.join(' ') ))
    ; __append("\">")
    ; 
if(fieldPath && !hidden){
if(!preventFieldLabel){
// if(!preventFieldLabel && field.atom.renderType !== 'checkbox' && field.atom.renderType !== 'toggle'){

    ; __line = 85
    ; __append( include('label', { formMapping: formMapping, model: field, config: labelConfig }) )
    ; 
}

    ; __line = 87
    ; __append( include(fieldPath, { formMapping: formMapping, model: field, config: fieldComponentConfig }) )
    ; 
// if(!preventFieldLabel && (field.atom.renderType === 'checkbox' || field.atom.renderType === 'toggle')){

    ; __line = 89
    ; 
// }
// checkboxes use the description as text right of the checkbox itself which conflicts with the tooltip (which is rendered according to the description field too).
if(field.description && field.atom.renderType !== 'checkbox'){

    ; __line = 93
    ; __append( include('form-text', { model: { message: field.description } }) )
    ; 
}
} else {
// TODO: hidden???

    ; __line = 97
    ; __append("<span class=\"hidden-")
    ; __append( field.fieldCode )
    ; __append("\"></span>")
    ; 
}

    ; __line = 99
    ; __append("</div>")
    ; 
}
else {
// TODO: hidden???

    ; __line = 103
    ; __append("<span class=\"hidden-")
    ; __append( field.fieldCode )
    ; __append("\"></span>")
    ; 
}
}
// TODO: render static fields
// else {
//     const renderType = formMapping.renderType;
//     const fieldCode = (formMapping.fieldCode || {}).tpl;
//     const fieldConfig = formMapping.fieldConfig || {};
//     const fieldPath = '../fields/' + renderType;
//     const fieldModel = {
//         fieldCode,
//         additionalCSSClass: (fieldConfig.additionalClasses || []).join(' ')
//     }
//
//     if(renderType && fieldCode){
//        

    ; __line = 118
    ; 
//    }
// }

    ; __line = 121
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\bootstrap5\form\elements\field.ejs

}